import Vue from 'vue';
import * as api from '@/gen/api';
import { AxiosResponse } from 'axios';
import { IThreeDSecureRepository } from '@/repositories/interface/IThreeDSecureRepository';

// ThreeDSecureRepository
// 3Dセキュア関連操作用リポジトリ
// 基本的にこれらを直接呼び出すことはなく、common配下のutilsを用いる。
export class ThreeDSecureRepository implements IThreeDSecureRepository {
  public constructor() {}

  private async createApiClient() {
    const config = await Vue.prototype.$getConfigWithToken(Vue.prototype.$auth);
    return new api.ThreeDSecureAuthApi(config);
  }
  public async beginProcess(
    redirectUrl: string,
    tenantId: string,
    payAmount: number,
    billingFullName: string,
    payToken?: string
  ): Promise<AxiosResponse<api.ResPostThreeDSecureAuthProcesses>> {
    const client = await this.createApiClient();
    const res = await client.postThreeDSecureAuthProcesses({
      redirect_url: redirectUrl,
      pay_token: payToken,
      tenant_id: tenantId as api.InlineObject7TenantIdEnum,
      pay_amount: payAmount,
      billing_full_name: billingFullName
    });
    return res;
  }

  public redirectToThreeDSecure(
    merchantId: string,
    encryptValue: string
  ): void {
    if (!process.env.VUE_APP_THREE_D_SECURE_URL) {
      throw new Error('3D secure URL is undefined');
    }
    // axiosを使用するとリクエストヘッダーに `sec-fetch-mode: cors` が設定されることで後続のリダイレクトにてCORSエラーが発生するためformを使用する
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = process.env.VUE_APP_THREE_D_SECURE_URL;

    const merchantIdInput = document.createElement('input');
    merchantIdInput.type = 'hidden';
    merchantIdInput.name = 'MerchantId';
    merchantIdInput.value = merchantId;
    form.appendChild(merchantIdInput);
    const encryptValueInput = document.createElement('input');
    encryptValueInput.type = 'hidden';
    encryptValueInput.name = 'EncryptValue';
    encryptValueInput.value = encryptValue;
    form.appendChild(encryptValueInput);

    document.body.appendChild(form);
    form.submit();
  }
}
